/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(8),
}));

export const HeadingBox = styled(Box)(() => ({
  maxWidth: '400px',
}));

export const HeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '36px',
  fontWeight: 400,
  lineHeight: '36px',
}));

export const DescriptionText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
}));

export const LeftBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
}));

export const DescriptionBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const TextWithIconBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),

  [`${theme.breakpoints.down('md')}`]: {
    '.MuiSvgIcon-root': {
      transform: 'rotate(90deg)',
    },
  },
}));
